module.exports = __webpack_public_path__ + "img/14.3ce64824.jpg";